import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  _createClass(Logger, null, [{
    key: "typeColor",
    value:
    /**
     * @description 返回这个样式的颜色值
     * @param {String} type 样式名称 [ primary | success | warning | danger | text ]
     */
    function typeColor() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
      var color = '';
      switch (type) {
        case 'default':
          color = '#35495E';
          break;
        case 'primary':
          color = '#3488ff';
          break;
        case 'success':
          color = '#43B883';
          break;
        case 'warning':
          color = '#e6a23c';
          break;
        case 'danger':
          color = '#f56c6c';
          break;
        default:
          break;
      }
      return color;
    }

    /**
     * @description 打印一个 [ title | text ] 样式的信息
     * @param {String} title title text
     * @param {String} info info text
     * @param {String} type style
     */
  }, {
    key: "capsule",
    value: function capsule(title, info) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'primary';
      console.log("%c ".concat(title, " %c ").concat(info, " %c"), 'background:#35495E; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;', "background:".concat(this.typeColor(type), "; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff;"), 'background:transparent');
    }

    /**
     * @description 打印彩色文字
     */
  }, {
    key: "_colorful",
    value: function _colorful(textArr) {
      var _console,
        _this = this;
      (_console = console).log.apply(_console, ["%c".concat(textArr.map(function (t) {
        return t.text || '';
      }).join('%c'))].concat(_toConsumableArray(textArr.map(function (t) {
        return "color: ".concat(_this.typeColor(t.type), ";");
      }))));
    }

    /**
     * @description 打印彩色文字
     */
  }, {
    key: "colorful",
    value: function colorful(text) {
      var _this2 = this;
      var index = 0;
      var texts = text.split('');
      this._colorful(texts.map(function (_text_) {
        if (index++ > _this2.types.length) {
          index = 0;
        }
        return {
          text: _text_,
          type: _this2.types[index]
        };
      }));
    }

    /**
     * @description 打印 default 样式的文字
     */
  }, {
    key: "default",
    value: function _default(text) {
      this._colorful([{
        text: text
      }]);
    }

    /**
     * @description 打印 primary 样式的文字
     */
  }, {
    key: "primary",
    value: function primary(text) {
      this._colorful([{
        text: text,
        type: 'primary'
      }]);
    }

    /**
     * @description 打印 success 样式的文字
     */
  }, {
    key: "success",
    value: function success(text) {
      this._colorful([{
        text: text,
        type: 'success'
      }]);
    }

    /**
     * @description 打印 warning 样式的文字
     */
  }, {
    key: "warning",
    value: function warning(text) {
      this._colorful([{
        text: text,
        type: 'warning'
      }]);
    }

    /**
     * @description 打印 danger 样式的文字
     */
  }, {
    key: "danger",
    value: function danger(text) {
      this._colorful([{
        text: text,
        type: 'danger'
      }]);
    }
  }]);
  return Logger;
}();
_defineProperty(Logger, "types", ['default', 'primary', 'success', 'warning', 'danger']);